import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import {
  Button,
  Col,
  Divider,
  Icon,
  Popconfirm,
  Row,
  Table,
  Avatar,
  Form
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import {
  getBarcodeRecycleByBarcodeId,
  getBarcodeRecycleItemByBarcodeProductId,
  deleteRecycleBarcodeProduct,
  updateBarcodeRecycleItem
} from '../../../../modules/barcodeProduct'
import EditRecycleBarcodeProduct from '../../../RecycleBarcodeProduct/EditRecycleBarcodeProduct'
import { useDeepEffect } from '../../../../utils/hooks'
import moment from 'moment'

const ProductRecycleList = ({ barcodeId }) => {
  const dispatch = useDispatch()
  const [openEditModal, setOpenEditModal] = useState(false)
  const [formData, setFormData] = useState({})

  const { recycleList, isLoading } = useSelector(
    (state) => ({
      recycleList: state.barcodeProduct.recycleList,
      isLoading: state.barcodeProduct.isLoading
    }),
    []
  )
  const GetDate = (d) => {
    let date = ''
    if (d !== null) {
      date = moment(d).format('DD/MM/YYYY')
    }
    return date
  }

  async function fetchData() {
    await dispatch(getBarcodeRecycleByBarcodeId(barcodeId, 0))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const openDialog = async (id) => {
    // Set data id
    await dispatch(getBarcodeRecycleItemByBarcodeProductId(id))
    await setOpenEditModal(true)
    await setFormData({
      id
    })
  }

  const onDelete = async (id) => {
    await dispatch(deleteRecycleBarcodeProduct(id))
    await dispatch(getBarcodeRecycleByBarcodeId(barcodeId, 0))
  }

  const columns = [
    {
      title: 'No.',
      key: 'No',
      width: 90,
      render: (name, row, index) => <div>{`${index + 1} `}</div>
    },
    {
      title: 'วัสดุที่ได้',
      key: 'material',
      dataIndex: 'material',
      render: (name, row) => (
        <div>
          {row.materialUrls && !isEmpty(row.materialUrls) ? (
            [...new Set(row.materialUrls)].map((material, index) => {
              return (
                <Avatar
                  key={material + index}
                  src={material}
                  size={43}
                  style={{ marginRight: 5 }}
                />
              )
            })
          ) : (
            <span>-</span>
          )}
        </div>
      )
    },
    {
      title: 'คะแนน',
      key: 'score',
      width: 200,
      render: (text, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <Row type="flex">
              <Col>
                <span style={{ fontSize: '18px' }}>{record.goodReaction}</span>
              </Col>
              <Col>
                <Icon
                  type="check-circle"
                  style={{ color: '#A4D55D', fontSize: '24px' }}
                />
              </Col>
            </Row>
          </Col>
          <Col>
            <Row type="flex">
              <Col>
                <span style={{ fontSize: '18px' }}>
                  {record.uncertainReaction}
                </span>
              </Col>
              <Col>
                <Icon type="minus-circle" style={{ fontSize: '24px' }} />
              </Col>
            </Row>
          </Col>
          <Col>
            <Row type="flex">
              <Col>
                <span style={{ fontSize: '18px' }}>{record.badReaction}</span>
              </Col>
              <Col>
                <Icon
                  type="close-circle"
                  style={{ color: '#FF6C6C', fontSize: '24px' }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )
    },
    {
      title: 'ผู้คัดแยก',
      key: 'createdBy',
      dataIndex: 'createdBy'
    },
    {
      title: 'วันที่สร้างวิธีคัดแยก',
      key: 'createDate',
      dataIndex: 'createDate',
      render: (createDate) => {
        const datesubmit = GetDate(createDate)
        return (
          <span>
            {datesubmit}
          </span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      width: 150,
      fixed: 'right',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={() => {
              openDialog(record.barcodeRecycleId)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.barcodeRecycleId)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  async function onChange(page) {
    await dispatch(getBarcodeRecycleByBarcodeId(barcodeId, page - 1))
  }

  const onOk = async (data) => {
    await dispatch(updateBarcodeRecycleItem(data))
    await setOpenEditModal(false)
    setFormData({})
    await dispatch(getBarcodeRecycleByBarcodeId(barcodeId, 0))
  }

  const onCloseModal = (key) => {
    setOpenEditModal(false)
    setFormData({})
  }

  return (
    <div>
      <Table
        loading={isLoading}
        scroll={{ x: 1200 }}
        bordered
        rowKey={(record) => `${record.productId}-${record.barcodeRecycleId}`}
        dataSource={recycleList.content}
        columns={columns}
        pagination={{
          current: !isEmpty(recycleList)
            ? recycleList.pageable.pageNumber + 1
            : 1,
          pageSize: 10,
          showSizeChanger: true,
          onChange: onChange,
          total: !isEmpty(recycleList) ? recycleList.totalElements : 0
        }}
      />
      <EditRecycleBarcodeProduct
        visible={openEditModal}
        formData={formData}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </div>
  )
}

const WrappedProductRecycleList = Form.create({
  name: 'ProductRecycleList'
})(ProductRecycleList)
export default WrappedProductRecycleList



// WEBPACK FOOTER //
// ./src/pages/BarcodeProduct/components/ProductRecycleList/index.js